import { Group, ActionIcon, Loader, useMantineTheme } from "@mantine/core";
import ActionCard from "src/components/ActionCard";
import { useEffect, memo } from "react";
import { IoIosArrowForward } from "react-icons/io";
import { TabsName } from "../Guest/GuestDetail";
import { useParams } from "react-router";
import {
  useGetAttendancePageClientGuestLazyQuery,
  useGetTransactionPageClientGuestLazyQuery,
} from "src/generated/graphql";
import { HistoryTableAttendance } from "../AttendanceTab";
import { HistoryTableTransaction } from "../TransactionHistory";

interface IProps {
  onTabChange: (tabName: TabsName) => void;
}

const TransactionAttendance = ({ onTabChange }: IProps) => {
  const theme = useMantineTheme();
  const { clientId } = useParams<{
    clientId: string;
  }>();

  const [
    getTransactions,
    { data: transactions, loading: transactionsLoading },
  ] = useGetTransactionPageClientGuestLazyQuery({});

  const [getAttendances, { data: attendances, loading: attendancesLoading }] =
    useGetAttendancePageClientGuestLazyQuery({});

  useEffect(() => {
    if (clientId) {
      getTransactions({
        variables: {
          pagination: {
            count: 3,
            filters: [
              {
                field: "chargedToId", // guestId ? "guestId" : "chargedToId",
                type: "text",
                value: clientId,
              },
            ],
          },
        },
      });

      getAttendances({
        variables: {
          pagination: {
            count: 3,
            filters: [
              {
                field: "clientId",
                type: "text",
                parentRelationField: "attendee",
                value: clientId,
              },
            ],
          },
        },
      });
    }
  }, [clientId]);

  return (
    <>
      <Group noWrap spacing="xs" my={10} align="stretch">
        <ActionCard
          title="Payments"
          rightIconButton={
            <ActionIcon
              onClick={() => onTabChange(TabsName.PAYMENTS)}
              sx={{
                color: theme.colors.primaryTextColor[6],
                "&:hover": {
                  backgroundColor: theme.colors.primary[4],
                },
              }}
            >
              <IoIosArrowForward />
            </ActionIcon>
          }
        >
          {transactions ? (
            HistoryTableTransaction(transactions?.transactionPage.items)
          ) : transactionsLoading ? (
            <Loader />
          ) : null}
        </ActionCard>
        <ActionCard
          title="Attendance"
          rightIconButton={
            <ActionIcon
              onClick={() => onTabChange(TabsName.ATTENDANCE)}
              sx={{
                color: theme.colors.primaryTextColor[6],
                "&:hover": {
                  backgroundColor: theme.colors.primary[4],
                },
              }}
            >
              <IoIosArrowForward />
            </ActionIcon>
          }
        >
          {attendances ? (
            HistoryTableAttendance(attendances?.attendancePage.items)
          ) : attendancesLoading ? (
            <Loader />
          ) : null}
        </ActionCard>
      </Group>
    </>
  );
};

export default memo(TransactionAttendance);
